import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IDisclaimerConfiguration, IDisclaimerProps, IDisclaimerState } from './models/index.js';
import Separator from './styledComponents/Separator.js';
import Superscript from './styledComponents/Superscript.js';
import Text from './styledComponents/Text.js';
import Wrapper from './styledComponents/Wrapper.js';
import { DISCLAIMER_CATEGORY_KEY, DISCLAIMER_COMPONENT_KEY } from './Disclaimer.meta.js';

export class Disclaimer extends ComponentBase<IDisclaimerProps, IDisclaimerState, IDisclaimerConfiguration> {
	categoryKey = DISCLAIMER_CATEGORY_KEY;
	componentKey = DISCLAIMER_COMPONENT_KEY;

	constructor(props: IDisclaimerProps) {
		super(props);
	}
	render() {
		const { className, text, hasHtmlContent, superscript, separator, isInline, useSeparator } = this.props;

		if (common.commonUtils.isNullOrUndefined(text)) {
			return null;
		}

		const wrapperStyle: React.CSSProperties = {};
		if (isInline) {
			wrapperStyle.display = 'inline';
		}
		return (
			<Wrapper className={className} style={wrapperStyle}>
				{superscript && <Superscript>{superscript}</Superscript>}
				{hasHtmlContent !== false ? (
					// eslint-disable-next-line @typescript-eslint/naming-convention
					<Text dangerouslySetInnerHTML={{ __html: text }} />
				) : (
					<Text>{text}</Text>
				)}
				{useSeparator && separator && <Separator>{separator}</Separator>}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Disclaimer), DISCLAIMER_CATEGORY_KEY, DISCLAIMER_COMPONENT_KEY);
